import { useMemo } from "react";
import { Box } from "@mui/material";
import MaterialReactTable from "material-react-table";
import { MRT_Localization_ES } from "material-react-table/locales/es";
import { buildColumnsPedidosRRHH } from "../config/columns";

const bgColorTableHeadCell = "rgba(212, 230, 241, 0.8)";

const PedidosTable = ({ data = [], loading }) => {
  const columns = useMemo(() => buildColumnsPedidosRRHH(), []);

  return (
    <Box boxShadow={1} sx={{ borderRadius: 2, overflow: "hidden" }}>
      <MaterialReactTable
        columns={columns}
        data={data}
        localization={MRT_Localization_ES}
        enableColumnActions={false}
        enableColumnFilters={false}
        enableColumnOrdering={false}
        enableGrouping={false}
        enableHiding={false}
        enableDensityToggle={false}
        state={{ isLoading: loading, showSkeletons: loading }}
        initialState={{ density: "compact", pagination: { pageIndex: 0, pageSize: 25 } }}
        muiSearchTextFieldProps={{
          placeholder: "Buscar..",
          sx: { minWidth: "14rem", backgroundColor: "#ffffff" },
          variant: "outlined",
          size: "small",
        }}
        muiTableHeadCellProps={{
          sx: {
            fontSize: 13,
            color: "black",
            fontWeight: "normal",
            backgroundColor: bgColorTableHeadCell,
            borderColor: "#FDFEFE",
          },
        }}
      />
    </Box>
  );
};

export default PedidosTable;
